<template>
  <span v-if="acoes.length" class="botao-tutorial">
    <v-menu v-if="acoes.length > 1" offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          id="btn--tutorial"
          :ripple="false"
          class="ma-1 font-weight-bold text-none"
          :class="classeBotao"
          height="39"
        >
          <v-icon left :dark="!claro">
            mdi-book-open-page-variant-outline
          </v-icon>
          {{ $t("Tutorial") }}
          <v-icon right :dark="!claro">mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item
          v-for="acao in acoes"
          :key="`${acao.tipo}-${acao.processo.id}`"
          @click="executar(acao)"
        >
          <v-list-item-icon class="mr-3">
            <v-icon small>{{ acao.icone }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ acao.processo.title }}</v-list-item-title>
            <v-list-item-subtitle>{{ $t(acao.rotulo) }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-btn
      v-else
      id="btn--tutorial"
      :ripple="false"
      :title="`${acoes[0].processo.title} · ${$t(acoes[0].rotulo)}`"
      class="ma-1 font-weight-bold text-none"
      :class="classeBotao"
      height="39"
      @click="executar(acoes[0])"
    >
      <v-icon left :dark="!claro">mdi-book-open-page-variant-outline</v-icon>
      {{ $t("Tutorial") }}
    </v-btn>
    <TutorialVisualizador
      v-model="lendo"
      :tutorial-id="selecionado ? selecionado.id : null"
      :titulo="selecionado ? selecionado.title : ''"
    />
  </span>
</template>

<script>
import TutorialVisualizador from "./TutorialVisualizador.vue";
import { carregarProcessosDisponiveis } from "@/services/tutorials/processosDisponiveis";
import { passosDoProcesso, processoDaTela } from "@/utils/tutoriais";

// Botão "Tutorial" das telas: lista os processos do Siga ligados à tela, para ler o tutorial
// em HTML e/ou seguir o passo a passo. Sem processo para a tela, não aparece.
export default {
  name: "BotaoTutorial",
  components: { TutorialVisualizador },
  props: {
    // Telas com uma ação principal própria usam o botão claro, como as demais ações secundárias.
    claro: { type: Boolean, default: false },
  },
  data() {
    return {
      processos: [],
      lendo: false,
      selecionado: null,
    };
  },
  computed: {
    classeBotao() {
      return this.claro
        ? "btn-ls btn-secondary bg-gradient-light px-5"
        : "btn-primary bg-gradient-primary py-3 px-6 ms-3";
    },
    acoes() {
      const rota = this.$route || {};
      return this.processos
        .filter((p) => p.active !== false && processoDaTela(p, rota))
        .flatMap((processo) => [
          ...(processo.hasStaticHtml
            ? [
                {
                  tipo: "ler",
                  processo,
                  rotulo: "Ler_tutorial",
                  icone: "mdi-book-open-page-variant-outline",
                },
              ]
            : []),
          ...(passosDoProcesso(processo).length
            ? [
                {
                  tipo: "passos",
                  processo,
                  rotulo: "Passo_a_passo",
                  icone: "mdi-play-circle-outline",
                },
              ]
            : []),
        ]);
    },
  },
  created() {
    carregarProcessosDisponiveis().then((lista) => {
      this.processos = lista;
    });
  },
  methods: {
    async executar(acao) {
      if (acao.tipo === "ler") {
        this.selecionado = acao.processo;
        this.lendo = true;
        return;
      }
      try {
        await this.$tutorials.start(passosDoProcesso(acao.processo));
      } catch (e) {
        this.$swal &&
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Nao_foi_possivel_iniciar_tutorial"),
            "error"
          );
      }
    },
  },
};
</script>
